import { render, staticRenderFns } from "./PracticeDetails.vue?vue&type=template&id=2a9bf463"
import script from "./PracticeDetails.vue?vue&type=script&lang=ts"
export * from "./PracticeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports